import React from 'react'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import isEmpty from 'lodash-es/isEmpty'

import { IArchiveGame } from 'protos'

import Grid from '@material-ui/core/Grid'
import ButtonBase from '@material-ui/core/ButtonBase'
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles'

import AdSlot from 'components/AdSlot'
import GameCard from 'components/GameCard'

interface Props {
  className?: string
  openQuiz: (gameId: string) => void
  adIndex: number
  hasAdSlot: boolean
  archiveGame: IArchiveGame
  gameDetailsUrl: string
}

const styles = createStyles({
  block: {
    display: 'block',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const GameCardButton: React.SFC<InjectedProps> = ({
  className,
  openQuiz,
  classes,
  adIndex,
  hasAdSlot,
  archiveGame,
  gameDetailsUrl,
}) => {
  const component = React.useCallback((props) => (
    <Link to={gameDetailsUrl} {...props} />
  ), [gameDetailsUrl])

  const { game, quiz } = archiveGame
  const displayQuizButton = !isEmpty(quiz)

  return (
    <div className={classNames(classes.block, className)}>
      <ButtonBase component={component} className={classes.block}>
        <GameCard
          game={archiveGame}
          displayQuizButton={displayQuizButton}
          onCickDisplayQuizButton={() => openQuiz(game!.gameId!)}
        />
      </ButtonBase>

      {hasAdSlot && (
        <Grid container justify="center">
          <AdSlot slotId={`game-history-slot-${Math.floor(adIndex / 7)}`} />
        </Grid>
      )}
    </div>
  )
}

export default React.memo(withStyles(styles)(GameCardButton))
